module.exports = __webpack_public_path__ + "media/images/icons/outlined/star-547553380813a9a7dc419448bc164dfc.svg";